import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { first, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QueryParametersService {
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly router = inject(Router);

  get(key: string): Observable<string | undefined> {
    return this.activatedRoute.queryParamMap.pipe(
      first(),
      map((queryParamMap: ParamMap) => queryParamMap.get(key)),
      map((query?: string | null) => query ?? undefined),
    );
  }

  clear(): Promise<boolean> {
    return this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {},
    });
  }
}
